export const kxdVerticalLang = {
    msg: {
        noData: '無資料，不能操作',
        pending: '資料載入中，請稍後',
        drawFirst: '請先畫線',
        moveVertical: '用滑鼠拖曳垂直剖面上有資料的點，即可移動剖面',
        loadData: '載入 {height} ...',
        loading: '資料載入中...',
        ok: '知道了'
    },
    ui: {
        control: '控制區',
        desc: '說明',
        draw: '畫線',
        show: '剖面',
        clear: '清除',
        reset: '重置視角',
        latlng: '經緯度',
        bg: '背景',
        flat: '拉平視窗',
        data: '資料清單',
        toggleAll: '全選 / 取消全選',
        rotate: '旋轉',
        terrain: '地形',
    },
    desc: [
        ['功能', '搭配鍵盤快捷鍵', '滑鼠操作介面'],
        ['各層資料顯示/隱藏', 'Shift+滑鼠左鍵點擊剖面', '滑鼠點擊資料清單中各層「開關」'],
        ['各層資料預覽', 'Shift+滑鼠在剖面上移動', '滑鼠在資料清單上移動'],
        ['資料數值反查', '', '滑鼠在資料上移動，顏色對照表將顯示滑鼠所在位置的數值'],
        ['資料篩選', '', '點擊顏色對照表上的色塊，可將資料對應色塊顯示/隱藏'],
        ['地圖移動', '', '按下滑鼠左鍵進行拖曳'],
        ['地圖旋轉', '', '按下滑鼠右鍵進行拖曳'],
        ['地圖上下移動', 'Alt+滑鼠左鍵進行拖曳', ''],
        ['產生剖面', '按住Ctrl+滑鼠點擊起點，拖曳後單擊產生中間點/雙擊產生終點，產生線段後，放開Ctrl即顯示剖面', '點擊 [{ui.draw}] 按鈕，滑鼠在地圖上點擊起點，拖曳後單擊產生中間點/雙擊產生終點，產生線段後，按下 [{ui.show}] 按鈕進行顯示'],
        ['剖面移動', '', '滑鼠左鍵拖曳剖面上有資料的點，能以平行原剖線方向移動剖面'],
        ['清除剖面', 'Esc', '點擊控制區 [{ui.clear}] 按鈕'],
        ['回到平面狀態', 'z', '點擊控制區 [{ui.reset}] 按鈕'],
        ['經緯度顯示/隱藏', 'x', '點擊控制區 [{ui.latlng}] 按鈕'],
        ['背景顯示/隱藏', 'c', '點擊控制區 [{ui.bg}] 按鈕'],
        ['剖面拉平視窗', 'v', '點擊控制區 [{ui.flat}] 按鈕'],
        ['地形顯示/隱藏', 't', '點擊控制區 [{ui.terrain}] 按鈕'],
        ['資料平滑', 's', '切換資料平滑模式'],
    ]
};
